import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../../Forms/SubmitButton/index.jsx';

import CurrencyFormatter from '@scripts/utilities/currency.js';


class CallToAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    if (this.props.onSubmit) {
      this.props.onSubmit(event);
    }

    this.setState({ loading: true });
  }

  render() {
    var selectedVariant = this.props.selected;

    // Set the button text.
    var buttonText;
    if (this.props.buttonText) {
      buttonText = this.props.buttonText;
    } else {
      buttonText = 'Start Now';      
    }

    return (
      <div className="cs-product-matrix-item-pricing">
        <p className="cs-product-matrix-item-pricing__description">
          {this.props.currency} <strong>{CurrencyFormatter(selectedVariant.price / selectedVariant.months, false)}</strong>/month*
        </p>
        <div className="cs-product-matrix-item-pricing__cta">
          <form
            action={window.location.pathname + window.location.search}
            method="post"
            encType="multipart/form-data"
            onSubmit={this.onSubmit}
          >
            <input type="hidden" name="quantity" value="1" />
            <input type="hidden" name="add-to-cart" value={selectedVariant.id} />
            <SubmitButton
              loading={this.state.loading}
              disabled={this.props.submitting}
              variant={this.props.featured ? 'gradient' : 'primary'}
            >
              {buttonText}
            </SubmitButton>
          </form>
        </div>
      </div>
    );
  }
}


CallToAction.propTypes = {
  buttonText: PropTypes.string,
  currency: PropTypes.string
};


export default CallToAction;

